import {
  getWorkOrdersPartnerControllerGetWorkOrderDetailQueryKey,
  type WorkOrderDetailDto,
} from '@artic/api-client';
import type { QueryClient } from '@tanstack/react-query';

/** The Orval response envelope (`{ status, data }`) the work-order hook resolves to. */
interface WorkOrderDetailResponse {
  status: number;
  data: WorkOrderDetailDto;
}

/**
 * Work-order name for the detail breadcrumb, read from the cached
 * `/work-orders/:workOrderId` response (loaded by the detail page). The key is
 * fully reconstructable (not partner-scoped), so we read it directly. Returns
 * null until the detail query has populated the cache, so the breadcrumb stays
 * empty rather than flashing a placeholder.
 */
export function readWorkOrderName(queryClient: QueryClient, workOrderId: string): string | null {
  const response = queryClient.getQueryData<WorkOrderDetailResponse>(
    getWorkOrdersPartnerControllerGetWorkOrderDetailQueryKey(workOrderId),
  );
  if (response?.status !== 200) return null;
  return response.data.work_order_name;
}
